export var machineProcessingFailedState = {
  type: 'final'
};